export default __webpack_public_path__ + "static/media/trinet-icon.c6d7ff6f.svg";